var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box"},[_c('breadcrumb',{attrs:{"breadcrumb":_vm.breadcrumb}}),(_vm.$menuList['SIS-Products-ProductInfo-Add'])?[_c('div',{staticClass:"card"},[_c('batch-add-card',{attrs:{"config":_vm.add}})],1)]:_vm._e(),(_vm.$menuList['SIS-Products-ProductInfo-Edit'])?[_c('batch-edit-card',{attrs:{"config":_vm.edit}})]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }